import {
	END_USER_ADDRESSES_FETCH_REQUEST,
	END_USER_ADDRESSES_FETCH_SUCCESS,
	END_USER_ADDRESSES_FETCH_FAILURE,
} from '../constants/actionTypes';

const initialState = {
	isFetching: false,
	endUsers: {},
};

export default function reducer(state = initialState, action) {
	const { type, payload } = action;

	switch (type) {
		case END_USER_ADDRESSES_FETCH_REQUEST:
			return {
				...state,
				isFetching: true,
			};

		case END_USER_ADDRESSES_FETCH_SUCCESS:
			return {
				...state,
				endUsers: {
					...state.endUsers,
					[payload.endUser]: payload.addresses,
				},
			};

		case END_USER_ADDRESSES_FETCH_FAILURE:
			return {
				...state,
				isFetching: false,
			};

		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/endUserAddresses.js